import {
    setLaunchProgress,
    getActiveLaunchProgress,
    getActiveRunningLaunchProgresses,
} from './data'

// Reducer is exposed so that we can hook up the state
export { default as launchProgressBarReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    setLaunchProgress, // Used by the User container
}

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    getActiveLaunchProgress, // Used by User and LaunchFrame
    getActiveRunningLaunchProgresses, // Used by UserList
}



// WEBPACK FOOTER //
// ./src/features/LaunchProgressBar/exports.js